import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { NormalizedWrapper } from '@theme'

import { config } from './config'
import { Wrapper, Description, Title, Container, ImageWrapper } from './styles'

const { title, description, images } = config

export function Wireframes() {
  return (
    <Wrapper>
      <NormalizedWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Container>
          {images.map(({ src, alt }) => (
            <ImageWrapper key={src}>
              <ImageWithPlaceholder src={src} alt={alt} fill />
            </ImageWrapper>
          ))}
        </Container>
      </NormalizedWrapper>
    </Wrapper>
  )
}
